/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiErrorResponse {
  Error: Error
}

export interface ContractCreateRequest {
  /**
   * Destination tenant id
   * @format int32
   */
  DestinationTenantId: number
  Version: ContractVersionCreateRequest
}

export interface ContractResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format date-time */
  CreatedOn: string
  /** @format date-time */
  UpdatedOn: string
  /** @format date-time */
  ChangesProposedOn?: string | null
  /** @format date-time */
  ValidFrom: string
  /** @format date-time */
  ValidTo: string
  /** @format int32 */
  UsersCount: number
  /** @format int32 */
  SourceTenantId: number
  SourceTenant: TenantResponse
  /** @format int32 */
  DestinationTenantId: number
  DestinationTenant: TenantResponse
  /**
   *
   *
   * 1 = Proposed
   *
   * 2 = Active
   *
   * 3 = Rejected
   *
   * 4 = Expired
   */
  Status: ContractStatus
  /** @format int32 */
  ActiveVersionId?: number | null
  /** @format int32 */
  LatestVersionId?: number | null
  HasChanges: boolean
}

/**
 *
 *
 * 1 = Proposed
 *
 * 2 = Active
 *
 * 3 = Rejected
 *
 * 4 = Expired
 * @format int32
 */
export enum ContractStatus {
  Proposed = 1,
  Active = 2,
  Rejected = 3,
  Expired = 4,
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Approved
 *
 * 2 = Rejected
 * @format int32
 */
export enum ContractVersionApprovalStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export interface ContractVersionBaseResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  ContractId: number
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Approved
   *
   * 2 = Rejected
   */
  Status: ContractVersionApprovalStatus
  IsActive: boolean
  IsLatest: boolean
}

export interface ContractVersionCreateRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * Valid to
   * @format date-time
   */
  ValidTo: string
  /**
   * Users
   * @minItems 1
   */
  Users: ContractVersionUserCreateRequest[]
  /**
   * Valid from
   * @format date-time
   */
  ValidFrom: string
}

export interface ContractVersionResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  ContractId: number
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Approved
   *
   * 2 = Rejected
   */
  Status: ContractVersionApprovalStatus
  IsActive: boolean
  IsLatest: boolean
  /**
   *
   *
   * 1 = Proposed
   *
   * 2 = Active
   *
   * 3 = Rejected
   *
   * 4 = Expired
   */
  ContractStatus: ContractStatus
  /** @format date-time */
  ValidFrom: string
  /** @format date-time */
  ValidTo: string
  /** @format int32 */
  SourceTenantId: number
  SourceTenant: TenantResponse
  /** @format int32 */
  DestinationTenantId: number
  DestinationTenant: TenantResponse
  Users: ContractVersionUserResponse[]
}

export interface ContractVersionUserCreateRequest {
  /** @format int32 */
  UserId: number
  /** @format uuid */
  IdentityGuid: string
}

export interface ContractVersionUserResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContractId: number
  /** @format int32 */
  ContractVersionId: number
  /** @format int32 */
  SourceUserProfileId: number
  /** @format int32 */
  DestinationUserProfileId?: number | null
}

export interface ContractsPagedResponse {
  /** @format int32 */
  TotalCount: number
  Items: ContractResponse[]
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface TenantResponse {
  /** @format int32 */
  Id: number
  Name: string
  Subdomain: string
}

export interface UsersContractorTenantsGetRequest {
  /**
   * @maxItems 100
   * @minItems 1
   */
  UserIds: number[]
}

export type GetPagedAsyncPayload = ContractStatus[]

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api.collaborate.local:44395/development/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Contractor service api
 * @version v1
 * @baseUrl https://api.collaborate.local:44395/development/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  contracts = {
    /**
     * No description
     *
     * @tags Contracts
     * @name GetPagedAsync
     * @summary Request is used to get list of contracts
     * @request GET:/contractor-service/api/contracts
     */
    getPagedAsync: (
      data: GetPagedAsyncPayload,
      query?: {
        /**
         * @format int32
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         * @default 50
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ContractsPagedResponse, ApiErrorResponse>({
        path: `/contractor-service/api/contracts`,
        method: 'GET',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name CreateAsync
     * @summary Request is used to create new contract
     * @request POST:/contractor-service/api/contracts
     */
    createAsync: (data: ContractCreateRequest, params: RequestParams = {}) =>
      this.http.request<ContractResponse, ApiErrorResponse>({
        path: `/contractor-service/api/contracts`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name GetAsync
     * @summary Request is used to get contract by id
     * @request GET:/contractor-service/api/contracts/{id}
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<ContractResponse, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name DeleteAsync
     * @summary Request is used to delete contract
     * @request DELETE:/contractor-service/api/contracts/{id}
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name GetUsersContractorTenantsAsync
     * @summary Request is used to get source tenants of users
     * @request POST:/contractor-service/api/contracts/get-users-contractor-tenants
     */
    getUsersContractorTenantsAsync: (data: UsersContractorTenantsGetRequest, params: RequestParams = {}) =>
      this.http.request<Record<string, TenantResponse>, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/get-users-contractor-tenants`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  contractsVersions = {
    /**
     * No description
     *
     * @tags ContractsVersions
     * @name GetContractVersionsAsync
     * @summary Request is used to get all contract versions
     * @request GET:/contractor-service/api/contracts/{contractId}/versions
     */
    getContractVersionsAsync: (contractId: number, params: RequestParams = {}) =>
      this.http.request<ContractVersionBaseResponse[], ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractsVersions
     * @name CreateAsync
     * @summary Request is used to create new contract version
     * @request POST:/contractor-service/api/contracts/{contractId}/versions
     */
    createAsync: (contractId: number, data: ContractVersionCreateRequest, params: RequestParams = {}) =>
      this.http.request<ContractVersionBaseResponse, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractsVersions
     * @name GetContractActiveVersionAsync
     * @summary Request is used to get active contract version
     * @request GET:/contractor-service/api/contracts/{contractId}/versions/active
     */
    getContractActiveVersionAsync: (contractId: number, params: RequestParams = {}) =>
      this.http.request<ContractVersionResponse, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions/active`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractsVersions
     * @name GetAsync
     * @summary Request is used to get contract version by id
     * @request GET:/contractor-service/api/contracts/{contractId}/versions/{versionId}
     */
    getAsync: (contractId: number, versionId: number, params: RequestParams = {}) =>
      this.http.request<ContractVersionResponse, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions/${versionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractsVersions
     * @name UpdateAsync
     * @summary Request is used to edit pending contract version
     * @request PUT:/contractor-service/api/contracts/{contractId}/versions/{versionId}
     */
    updateAsync: (
      contractId: number,
      versionId: number,
      data: ContractVersionCreateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions/${versionId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractsVersions
     * @name ApproveAsync
     * @summary Request is used to approve proposed contract version
     * @request PUT:/contractor-service/api/contracts/{contractId}/versions/{versionId}/status/approve
     */
    approveAsync: (contractId: number, versionId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions/${versionId}/status/approve`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractsVersions
     * @name RejectAsync
     * @summary Request is used to reject proposed contract version
     * @request PUT:/contractor-service/api/contracts/{contractId}/versions/{versionId}/status/reject
     */
    rejectAsync: (contractId: number, versionId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/contractor-service/api/contracts/${contractId}/versions/${versionId}/status/reject`,
        method: 'PUT',
        ...params,
      }),
  }
}
